import React from 'react';
import { Alert, Snackbar } from '@mui/material';

export type SnackbarSeverity = 'success' | 'error' | 'info' | 'warning';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
}

interface CustomSnackbarProps {
  state: SnackbarState;
  onClose: () => void;
  autoHideDuration?: number;
}

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  state,
  onClose,
  autoHideDuration = 3000,
}) => {
  return (
    <Snackbar
      open={state.open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity={state.severity}
        variant="filled"
        className="w-full"
      >
        {state.message}
      </Alert>
    </Snackbar>
  );
};

// Custom hook to manage snackbar state
export const useSnackbar = (initialState?: Partial<SnackbarState>) => {
  const [snackbar, setSnackbar] = React.useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success',
    ...initialState,
  });

  const showSnackbar = (message: string, severity: SnackbarSeverity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const hideSnackbar = () => {
    setSnackbar(prev => ({
      ...prev,
      open: false,
    }));
  };

  return {
    snackbar,
    showSnackbar,
    hideSnackbar,
  };
};

export default CustomSnackbar;